/*
 * File: d:\projects\AutoFiFront\src\Services\ServiceGeneral.ts
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday January 13th 2023 2:10:45 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import UserSession from "Utils/UserSession";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import AuthenticationError from "Error/AuthenticationError";
import { AxiosResponse } from "axios";

/**
 * Helps manage and centralize common behavior of services
 */
class ServiceGeneral {
  static END = "end";
  static CONTINUE = "continue";

  /**
   * Manage the response of axios (Redirect to login if 401, redirect to page error if 500)
   * @param {Object} data The data returned by axios
   * @param {*} history The history object of react router
   * @returns continue if we should continue operations, end if the compoenent calling this function should stop
   */
  static async handleAxiosResponse(data: AxiosResponse<any, any>) {
    const status = data.status;

    switch (status) {
      case 500:
        return ServiceGeneral.END;
      case 401:
        throw new AuthenticationError("Identification expired.");
      default:
        break;
    }
    return ServiceGeneral.CONTINUE;
  }

  /**
   * Check if the server is reached, if yes returns the response otherwise returns a server error like response
   * @param {*} error The axios error
   */
  static interpretError(error: any) {
    if (error.response === undefined) {
      return {
        status: 500,
        data: {},
      };
    } else if (error.response.status === 401) {
      throw new AuthenticationError("Identification expired.");
    }

    return error.response;
  }
}

export default ServiceGeneral;
